import React from 'react';
import TableComp from '../../../../../components/Table/TableComp'
import useSafeState from '../../../../../useSafeState' 
import * as api from '../../../../../Auth/auth'



export function Skin_Variants_TableData() {

  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(React.useMemo(() => []));
  const [loading, setLoading] = React.useState(false);
    
    React.useEffect( () => {
      getData()
  }, [])

  async function getData() {
    
    setLoading(true)
    const response = await api.Skin_Variants_ListFetch();
    const d = handleData(response)
    setData( d )
    setLoading(false)
           // NO MEMORY LEAK
    setValue({ key: 'value' });
    }



    const handleData = (response) => {
      let dataContainer = []
              for (let i in response) {      
                dataContainer.push(    {    'col1': response[i].id,
                                            'col2': response[i].SYMBOL,
                                            'col3': response[i].VARIANT_CLASS,
                                            'col4': response[i].Uploaded_variation,
                                            'col5': response[i].Consequence,
                                            'col6': response[i].Existing_variation,
                                            'col7': response[i].CLIN_SIG,
                                            'col8': response[i].PUBMED,
                                            'col9': response[i].owner,
                                        },
                                  );   
              }
              return (dataContainer)
            }

  const columns = React.useMemo(
      () => [
        {
          header: 'Variant',
          accessorKey: 'col3',
          cell: info => info.getValue(),
          },
          {
            header: 'Position / Variation',
            accessorKey: 'col4',
            cell: info => info.getValue(),
            },
            {
              header: 'Variation Type',
              accessorKey: 'col5',
              cell: info => info.getValue(),
              },
              {
                header: 'Variation ID',
                accessorKey: 'col6',
                cell: info => info.getValue(),
                },
                {
                  header: 'clinvar classificaton',
                  accessorKey: 'col7',
                  cell: info => info.getValue(),
                  },
                  {
                    header: 'PubMed',
                    accessorKey: 'col8',
                    cell: info => info.getValue(),
                    },                         
      ],
      []
      )

return (

<div>
      { loading && <span> Please wait ... fetching data </span>}
      <TableComp columns={columns} data={data} />
</div>
);
}